import { CSSProperties } from "react";
import { aepPalette } from "../../../styles/aepPalette";

export const iconStyles: CSSProperties = {
  color: aepPalette.font.dark,
  cursor: "pointer",
};
